import React, {useEffect, useState} from 'react';
import "./VideoClickReveal.sass"
import renderHTML from 'react-render-html';
import CheckCircle from "../../../icons/check_circle_inverse.svg"
import Button from "../../ui/Button/Button";
import apiJSON from "../../../api/apiJSON";

const VideoClickReveal = ({data, completed, style, next}) => {

    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [tracking, setTracking] = useState([]);
    const [finished, setFinished] = useState(false);

    const jsonData = apiJSON.get(data);
    const scenario = jsonData.scenario;

    useEffect(() => {
        if (checkCompleted()) {
            setFinished(true);
        }
    }, [tracking]);

    useEffect(() => {
        let t = tracking.slice();
        if (t.length === 0) {
            scenario.choiceSet.choices.map((index) => {
                t.push(0)
            });
        } else {
            t[selectedIndex] = 1;
        }
        console.log("t: " + t)
        setTracking(t)
    }, [selectedIndex]);

    const handleDone = () => {
        if (next) next();
    }

    const checkCompleted = () => {
        let c = (tracking.length > 0 && tracking.indexOf(0) === -1);
        if (c && completed) completed();
        return c
    }

    const handleSelect = (event, index) => {
        console.log("handleSelect(" + index + ")");
        setSelectedIndex(index);
    }

    const videoEnded = (event) => {
        setSelectedIndex(-1)
    }


    return (
        <div className="VideoClickReveal"
             style={style || {}}>
            {
                scenario &&
                <div className="video-clickreveal-question-panel">
                    <div className="video-clickreveal-question-textbox">
                        <div className="video-clickreveal-question-title">
                            {scenario.title}
                        </div>
                        <div className="video-clickreveal-question-body">
                            {scenario.body}
                        </div>
                    </div>
                    {
                        scenario.choiceSet.choices.map((choice, index) => (
                            <div className={"video-clickreveal-choice" + ((index === selectedIndex) ? " selected" : "")}
                                 onClick={(event) => handleSelect(event, index)}
                                 key={"choice" + index}
                                 id={"choice" + index}>
                                {choice.label}
                                <div className={"video-clickreveal-check" + (tracking[index] === 0 ? " invisible" : "")}>
                                    <img src={CheckCircle}
                                         alt="check-mark"/>
                                </div>
                            </div>
                        ))
                    }
                </div>
            }
            {
                scenario &&
                <div className="video-clickreveal-player-panel">
                    <div className="video-clickreveal-player-holder">
                        {
                            (selectedIndex === -1) ?
                                <img src={scenario.choiceSet.image}
                                     alt={scenario.choiceSet.title}
                                     style={{
                                         "maxHeight": "100%",
                                         "width": "auto"
                                     }}/> :
                                <video src={scenario.choiceSet.choices[selectedIndex].video}
                                       autoPlay={true}
                                       onEnded={videoEnded}
                                       controls/>
                        }
                    </div>
                    <div className="video-clickreveal-video-panel-caption">
                        {renderHTML(scenario.choiceSet.title)}
                    </div>
                    <Button data={scenario.doneLabel ? scenario.doneLabel : "Done"}
                            callback={handleDone}
                            disabled={!(finished)}/>
                </div>
            }
        </div>
    )
};

export default VideoClickReveal;